// Textos multi-idioma {es,en,fr} del backend (category.name/description, article.name...).
// El admin trabaja en español: prioriza 'es' y cae a 'en'/'fr'/string plano.
export function getMultilangText(value) {
    if (!value) return ''
    if (typeof value === 'string') return value

    return value.es || value.en || value.fr || Object.values(value)[0] || ''
}
